import React from "react";
import { BrandLogo } from "@/components/flow/BrandLogos";
import { t } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/* ---------------------------------------------------------------------------
   One quiet compatibility line, identical wherever it appears (home hero,
   early-access hero, integrations): "Fits into your existing workflow —
   Guesty · Hostaway · Lodgify · Smoobu · + any PMS". A promise about fit, not a
   partnership wall — and never "Works with".
--------------------------------------------------------------------------- */

export const PMS_IDS = ["guesty", "hostaway", "lodgify", "smoobu"];

export function WorkflowFit({ className, scale = 0.9, eyebrow = true, testId = "workflow-fit" }) {
  return (
    <div className={cn("min-w-0", className)} data-testid={testId}>
      {eyebrow && <p className="text-[11.5px] font-medium uppercase tracking-[0.14em] text-ink/40">{t("fit.eyebrow")}</p>}
      <div className={cn("flex flex-wrap items-center gap-x-7 gap-y-3 text-ink/45", eyebrow && "mt-3.5")}>
        {PMS_IDS.map((id) => (
          <span key={id} className="inline-flex items-center transition-colors duration-200 hover:text-ink/75" data-testid={`${testId}-${id}`}>
            <BrandLogo id={id} scale={scale} />
          </span>
        ))}
        <span className="inline-flex items-center h-6 rounded-full border border-hairline bg-surface/70 px-2.5 text-[12px] font-medium text-ink/55" data-testid={`${testId}-any`}>{t("fit.any_pms")}</span>
      </div>
    </div>
  );
}
